import { Params } from '../interface/core.interface';

export class GetUserTransactionAction {
  static readonly type = '[Wallet] Transaction Get';
  constructor(public payload?: Params) {}
}
